import { getApi } from "../apiCall";

export const getMetrics = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/metrics`;
  return getApi(url);
};

export const getAdmins = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/admins`;
  return getApi(url);
};

export const getAllCompanies = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/companies-with-admins`;
  return getApi(url);
};

export const getCompanyByStateId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/companies/by-stateUtId/${id}`;
  return getApi(url);
};

export const getCompanyById = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${id}/getFullCompanyDetails`;
  return getApi(url);
};

export const getConsumersByCompId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${id}/getCompanyConsumers`;
  return getApi(url);
};

export const getFullConsumerDetails = (consumerId) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${consumerId}/getFullConsumerDetails`;
  return getApi(url);
};

export const getGeneratorsByCompId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${id}/getCompanyGenerators`;
  return getApi(url);
};

export const getFullGeneratorDetails = (generatorId) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${generatorId}/getFullGeneratorDetails`;
  return getApi(url);
};

export const getDiscomsByCompId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${id}/getCompanyDiscoms`;
  return getApi(url);
};

export const getAllTraders = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/trader/getAllTraders`;
  return getApi(url);
};

export const getAdminConsumerCapacityListing = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/super-admin/capacity/consumer/list?consumerId=${id}&currentPage=0&size=10000`;
  return getApi(url);
};

export const getAdminGeneratorCapacityListing = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/super-admin/capacity/generator/list?generatorId=${id}&currentPage=0&size=10000`;
  return getApi(url);
};

export const getAdminGeneratorRaListing = ({ id, type, companyId }) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/super-admin/tender/getTendersForBidders?generatorId=${id}&tenderType=${type}&companyId=${companyId}&currentPage=0&size=10000`;
  return getApi(url);
};

export const getAdminConsumerRaListing = ({ id, type }) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/super-admin/tender/list?consumerId=${id}&tenderType=${type}&currentPage=0&size=10000`;
  return getApi(url);
};

export const getRequistionAdminConsumerRaListing = ({
  id,
  bidStage,
  consumerId,
}) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/super-admin/tender/${id}/getRequisitions?bidStage=${bidStage}&consumerId=${consumerId}`;
  return getApi(url);
};

export const getListingTermsConfiguration = ({ id, userId, type }) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/super-admin/connection/get/${id}?${userId}&${type}&listingView=true
`;
  return getApi(url);
};

export const viewSettlementSchedule = ({ type, companyId }) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/super-admin/repSchedule/getAllByScheduleId?${type}&currentPage=0&size=1000000&companyId=${companyId}`;
  return getApi(url);
};

export const getBankingListings = ({ companyId }) => {
  let url = `${process.env.REACT_APP_API_URL}/banking/super-admin/list?currentPage=0&size=100000000&companyId=${companyId}`;
  return getApi(url);
};

export const getParentPaymentDetails = ({ role, userId }) => {
  let url = `${process.env.REACT_APP_API_URL}/powerschedules/super-admin/repSchedule/${role}?userId=${userId}&currentPage=0&size=1000`;
  return getApi(url);
};
